























import {
  computed,
  defineComponent,
  PropType,
} from '@nuxtjs/composition-api';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import type { HydrogenCountryOption } from '~/constants/hydrogenCountryOptions';

export default defineComponent({
  name: 'HydrogenCountrySelect',
  components: {
    VSelect: vSelect,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    options: {
      type: Array as PropType<HydrogenCountryOption[]>,
      default: () => [],
    },
    selectId: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: 'country',
    },
    chinaLabel: {
      type: String,
      default: 'China',
    },
    placeholder: {
      type: String,
      default: 'Choose Country',
    },
    noOptionsText: {
      type: String,
      default: 'No matching search results',
    },
  },
  setup(props, { emit }) {
    const countryOptions = computed<HydrogenCountryOption[]>(() => [
      { value: 'CN', label: props.chinaLabel },
      ...props.options,
    ]);
    const reduceCountryOption = (option: HydrogenCountryOption) => option.value;
    const filterByCountry = (option: HydrogenCountryOption, label: string, search: string) => {
      const normalizedSearch = search.toLocaleLowerCase();

      return label.toLocaleLowerCase().includes(normalizedSearch)
        || option.value.toLocaleLowerCase().includes(normalizedSearch);
    };
    const onInput = (selectedValue: string | null) => {
      emit('input', selectedValue || '');
    };

    return {
      countryOptions,
      filterByCountry,
      onInput,
      reduceCountryOption,
    };
  },
});
